/**
 * Will initialize the application.
 */

import Vue from 'vue';

/**
 * Import and bootstrap the plugins.
 */
import './bootstrap';
import './sass/style.scss'
import router from './router';
import store from './store';
import i18n from './plugins/lang';
import './plugins/toastr';
import './plugins/angle';
import './plugins/validator';
import './plugins/meta';

/**
 * Main App.
 *
 * Last but not least, we import the main application.
 */

import App from './pages/App.vue';

store.dispatch('auth/checkLogged');

/**
 * Insert language for blockly.
 */
let messageScript = document.createElement( 'script' );
messageScript.setAttribute('src', `./static/js/msg/js/${store.getters['auth/currentLang']}.js`);
messageScript.onload = () => store.commit('auth/WORKSPACE_LANGUAGE_LOADED', true);
document.body.appendChild(messageScript);

window.invokeCSCode = (data) => {
    invokeCSharpAction(data);
};

window.invokeJoystickCSCode = (data) => {
    callJoystickAction(data);
};

window.getLanguage = () => {
    return {
        language: store.getters['auth/currentLang'],
        direction: store.getters['auth/currentDirection'],
    };
};

window.isExistsInvokeCSCode = () => {
    try {
        return Boolean(invokeCSharpAction);
    } catch (e) {
        return false;
    }
};

Vue.config.productionTip = false;

/* eslint-disable no-new */
window.mainApp = new Vue({
    router,
    store,
    i18n,
    render: h => h(App),
}).$mount('#app');

window.setScannedDevices = (devices = []) => {
    window.mainApp.$store.dispatch('device/setScannedDevices', devices);
};

window.addDevice = (id, type, name) => {
    const deviceInfo = {
        id,
        type,
        name,
    };

    window.mainApp.$store.dispatch('device/addDevice', deviceInfo);
};

window.clearDeviceList = () => {
    window.mainApp.$store.dispatch('device/setScannedDevices', []);
};

window.connectDevice = () => {
    return window.mainApp.$store.getters['device/connected'];
};

window.disconnectDevice = () => {
    window.mainApp.$store.dispatch('device/disconnectDevice', {});
};

window.setTerminalData = (text) => {
    window.mainApp.$store.dispatch('device/setTerminalData', {
        time: window.moment(),
        text,
    });
};

window.openCommunicationTab = () => {
    window.mainApp.$store.commit('menu/COMMUNICATION', true);
};

window.setAppVersion = (version) => {
    window.mainApp.$store.commit('menu/APP_VERSION', version);
};

window.clearTerminalData = () => {
    window.mainApp.$store.dispatch('device/clearTerminalData');
};

window.enableUSBTab = () => {
    window.mainApp.$store.dispatch('device/setStatusUsbTab', true);
    window.mainApp.$store.dispatch('device/activeTab', 'usb');
};

window.enableBTTab = () => {
    window.mainApp.$store.dispatch('device/setStatusBtTab', true);
    window.mainApp.$store.dispatch('device/activeTab', 'bluetooth');
};

window.showUpdateButton = () => {
    window.mainApp.$store.dispatch('device/setUpdateOsStatus', true);
};

window.turnJoystickLightOn = () => {
    window.mainApp.$children[0].$children[0].turnJoystickLightOn();
};

window.turnJoystickLightOff = () => {
    window.mainApp.$children[0].$children[0].turnJoystickLightOff();
};

window.showJoystickIcon = () => {
    window.mainApp.$children[0].$children[0].showJoystickIcon();
};

window.hideJoystickIcon = () => {
    window.mainApp.$children[0].$children[0].hideJoystickIcon();
};

window.lockJoystickLeftNipple = () => {
    window.mainApp.$children[0].$children[0].lockJoystickLeftNipple();
};

window.unlockJoystickLeftNipple = () => {
    window.mainApp.$children[0].$children[0].unlockJoystickLeftNipple();
};

window.lockJoystickRightNipple = () => {
    window.mainApp.$children[0].$children[0].lockJoystickRightNipple();
};

window.unlockJoystickRightNipple = () => {
    window.mainApp.$children[0].$children[0].unlockJoystickRightNipple();
};

window.openNewProject = () => {
    window.mainApp.$children[0].$children[0].newFile();
};

window.getLevel = () => {
    return window.mainApp.$children[0].$children[0].curentLevel;
};

window.setLevel = (level) => {
    window.mainApp.$children[0].$children[0].changeToolbox(level);
};

window.setXMLToWorkspace = (xmlString) => {
    window.mainApp.$children[0].$children[0].setXMLToWorkspace(xmlString);
};

window.getWorkspaceXML = () => {
    return window.mainApp.$children[0].$children[0].download;
};

window.getWorkspaceCode = () => {
    return window.mainApp.$children[0].$children[0].code;
};

window.showHelp = (blockInstance) => {
    window.mainApp.$children[0].$children[0].showHelp(blockInstance);
};

window.openDownloadingPopup = () => {
    window.mainApp.$children[0].$data.DownloadPopup = true;
};

window.closeDownloadingPopup = () => {
    window.mainApp.$children[0].$data.DownloadPopup = false;
};

window.setDownloadingPopupDescription = (description) => {
    window.mainApp.$children[0].$data.downloadDescription = description;
};

window.setDownloadingProgress = (percent) => {
    window.mainApp.$children[0].$data.DownloadPopupPercent = percent;
};

window.openErrorPopup = () => {
    window.mainApp.$children[0].$data.ErrorDownloadPopup = true;
};

window.closeErrorPopup = () => {
    window.mainApp.$children[0].$data.ErrorDownloadPopup = false;
};

window.setErrorPopupTitle = (title) => {
    window.mainApp.$children[0].$data.errorPopupTitle = title;
};

window.setErrorPopupDescription = (description) => {
    window.mainApp.$children[0].$data.errorPopupDescription = description;
};

window.openScanningPopup = () => {
    window.mainApp.$children[0].$data.ScanningPopup = true;
};

window.closeScanningPopup = () => {
    window.mainApp.$children[0].$data.ScanningPopup = false;
};



// WEBPACK FOOTER //
// ./src/main.js